export const mapSimulationValues = ({ currentValue, productType, kind, isConsumer, advancePayment }) => ({
  amount: currentValue,
  productType,
  kind,
  downpayment: isConsumer ? '' : advancePayment
});
